import { z } from "zod";

export const getConnectedVehiclesDataProvidersByCompanyPayloadSchema = z.object(
  {
    companyUuid: z.uuid(),
  },
);

export type GetConnectedVehiclesDataProvidersByCompanyPayload = z.infer<
  typeof getConnectedVehiclesDataProvidersByCompanyPayloadSchema
>;
